export default "__VITE_ASSET__$A$dY77u__"